import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import QuoteForm from './modules/QuoteForm'
import LeadForm from './modules/LeadForm'
import QuoteOptions from './modules/QuoteOptions'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    QuoteForm,
    LeadForm,
    QuoteOptions
  }
})




// WEBPACK FOOTER //
// ./src/store/store.js